import request from "@/utils/axios";
import axios from "axios";

//  登录
export function LOGIN(data) {
  return request({
    url: '/api/users/login',
    method: 'post',
    data
  })
}
// 获取验证码
export function CODE(data) {
  return request({
    url: '/api/users/code',
    method: 'post',
    data
  })
}
// 获取验证码
export function PHONECODE(data) {
  return request({
    url: '/api/users/captcha',
    method: 'post',
    data
  })
}
// 获取注册
export function REGIST(data) {
  return request({
    url: '/api/users/regist',
    method: 'post',
    data
  })
}
// 获取验证码 忘记密码
export function CODEFORPASSWORD(data) {
  return request({
    url: '/api/users/codeForPassword',
    method: 'post',
    data
  })
}
// 邮箱验证
export function EMAILVERIFY(data) {
  return request({
    url: '/api/users/verify',
    method: 'post',
    data
  })
}

// 更改密码
export function PASSWORD(data) {
  return request({
    url: '/api/users/password',
    method: 'put',
    data
  })
}
//  获取登录信息
export function QUERY(data) {
  return request({
    url: '/api/users/query',
    method: 'get',
    data
  })
}

//  个人中心-展示购买记录
export function RECORDS(data) {
  return request({
    url: '/api/orderpay/records',
    method: 'post',
    data
  })
}
//  个人中心-下单获取微信二维码
export function QRCODEURL(data) {
  return request({
    url: '/api/orderpay/qRCodeUrl',
    method: 'POST',
    data
  })
}


//  获取登录信息
export function GETURLBYID(data) {
  return axios({
    baseURL: 'https://www.foshoaff.com',
    url: '/api/open/pdf/getUrlById',
    method: 'get',
    params:data
  })
}